import { ReactElement } from 'react';

import { useNavigation } from '@refinedev/core';

import { ArrowLeftIcon } from '@rrexpress/core';

import ActionDelete from '../action-button/delete';
import ActionUpdate from '../action-button/update';
import { BaseCard } from '../card';
import { LoadingOverlay } from '../loading-overlay/loading-overlay';

export interface IBaseShow {
  title?: string;
  children: ReactElement;
  isLoading?: boolean;
  id?: string;
  resource?: string;
  onDelete?: () => void;
  onUpdate?: () => void;
  hasBack?: boolean;
}

export const BaseShow: React.FC<IBaseShow> = (props: IBaseShow) => {
  const {
    title,
    children,
    isLoading,
    id,
    resource,
    onDelete,
    onUpdate,
    hasBack = true,
  } = props;
  const { goBack, edit, list } = useNavigation();

  return (
    <LoadingOverlay
      isLoading={!!isLoading}
      variant="circular"
      size={64}
      paddingTop={64}
    // variant="line"
    // size={4}
    // paddingTop={0}
    >
      <BaseCard>
        <div className="mb-8 flex justify-between items-center">
          <div className="flex font-bold items-center space-x-2">
            {hasBack && (
              <div
                className="hover:text-gray-400 cursor-pointer"
                onClick={() => (resource ? list(resource) : goBack)}
              >
                <ArrowLeftIcon />
              </div>
            )}
            <h1 className="text-xl">{title}</h1>
          </div>
          <div className="flex font-bold items-center space-x-2">
            {(resource && id) && (
              <ActionUpdate onClick={() => (onUpdate ? onUpdate() : edit(resource, id))} />
            )}

            {onUpdate && (
              <ActionUpdate onClick={() => onUpdate()} />
            )}

            {onDelete && ( // temporary for custom delete action | jangan dulu dihapus hehe 😁
              <ActionDelete onClick={() => onDelete()} />
            )}
          </div>
        </div>
        {children}
      </BaseCard>
    </LoadingOverlay>
  );
};
